<template>
  <component :is="layout">
    <Loader />
    <router-view :key="viewKey" />
  </component>
</template>

<script>
import Footer from "./components/Footer/Footer.vue";
import MainMenu from "./components/MainMenu.vue";
import Loader from "./components/Loader.vue";

export default {
  components: { "aa-footer": Footer, MainMenu, Loader },
  data: () => ({
    drawer: false,
    isPreload: true,
  }),
  computed: {
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    },
    // The order page only loads its art when it mounts, so moving between
    // artworks (e.g. the Similar Art carousel) must remount it. Keyed only
    // for this route so other pages keep their existing behaviour.
    viewKey() {
      return this.$route.name === "Order" ? this.$route.fullPath : undefined;
    },
  },
  methods: {},
  updated: function() {
    this.$nextTick(function() {
      // console.log("End loading new");
      document.querySelector("html").classList.remove("on-scroll");
    });
  },
};
</script>
